function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "United",
    clipPath: "url(#clip0_1_13495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9995 0.6875C9.05731 0.689052 7.15507 1.23901 5.51172 2.27407H16.4722C14.8332 1.24172 12.9365 0.691876 10.9995 0.6875Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.51184 2.27368C4.80392 2.72183 4.15325 3.25459 3.57422 3.86017H18.4371C17.8497 3.25284 17.1898 2.72002 16.4723 2.27368H5.51184Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5756 3.86011C3.10754 4.34672 2.6884 4.87813 2.32422 5.44668H19.6896C19.3255 4.87815 18.9065 4.34674 18.4385 3.86011H3.5756Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.32216 5.44629C1.99667 5.94971 1.71569 6.48054 1.48242 7.03278H20.5078C20.2808 6.48122 20.0063 5.9504 19.6875 5.44629H2.32216Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.48254 7.03442C1.27138 7.54878 1.10217 8.07936 0.976562 8.62099H21.0207C20.8929 8.07916 20.7214 7.54857 20.508 7.03442H1.48254Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.976906 8.62061C0.852337 9.14215 0.768635 9.67262 0.726562 10.2072H21.2783C21.234 9.67243 21.148 9.14197 21.0211 8.62061H0.976906Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.727196 10.2068C0.703783 10.4706 0.690541 10.7352 0.6875 11C0.688503 11.2648 0.699701 11.5294 0.721069 11.7933H21.2728C21.2962 11.5295 21.3095 11.2649 21.3125 11C21.3115 10.7353 21.3003 10.4707 21.2789 10.2068H0.727196Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0.720703 11.7932C0.765038 12.328 0.851041 12.8584 0.977928 13.3798H21.0221C21.1467 12.8582 21.2304 12.3278 21.2724 11.7932H0.720703Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M0.978516 13.3794C1.10634 13.9212 1.27782 14.4518 1.49129 14.966H20.5167C20.7279 14.4516 20.8971 13.921 21.0227 13.3794H0.978516Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M1.49023 14.9656C1.71729 15.5171 1.99177 16.048 2.31059 16.5521H19.6759C20.0014 16.0486 20.2824 15.5178 20.5157 14.9656H1.49023Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.31055 16.5537C2.67462 17.1222 3.09365 17.6536 3.56159 18.1403H18.4245C18.8926 17.6537 19.3117 17.1223 19.6759 16.5537H2.31055Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M3.5625 18.1399C4.14997 18.7472 4.80985 19.28 5.52731 19.7264H16.4878C17.1957 19.2782 17.8464 18.7455 18.4254 18.1399H3.5625Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M5.52734 19.7263C7.16637 20.7587 9.06302 21.3085 11.0001 21.3129C12.9422 21.3113 14.8445 20.7614 16.4878 19.7263H5.52734Z",
    fill: "#952734",
    style: {
      fill: "#952734",
      fill: "color(display-p3 0.5841 0.1514 0.2055)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M11 0.6875C8.26496 0.6875 5.64193 1.77399 3.70796 3.70796C1.77399 5.64193 0.6875 8.26496 0.6875 11C0.688849 11.2725 0.701 11.5449 0.723923 11.8164H11.8164V0.728371C11.5449 0.703963 11.2726 0.690328 11 0.6875Z",
    fill: "#3C3B6E",
    style: {
      fill: "#3C3B6E",
      fill: "color(display-p3 0.2353 0.2314 0.4314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.30962 1.38276C7.17222 1.43292 7.03589 1.486 6.90075 1.54196L7.05139 1.65643L6.94951 1.98567L7.21941 1.78417L7.49719 1.99532L7.39287 1.65459L7.67066 1.44721H7.32934L7.30962 1.38276ZM9.05889 1.10107L8.95174 1.44719H8.61161L8.88694 1.65646L8.78503 1.98564L9.05491 1.78416L9.33272 1.9953L9.2284 1.65463L9.50617 1.44719H9.16489L9.05889 1.10107ZM10.8944 1.10107L10.7873 1.44719H10.4471L10.7225 1.65646L10.6205 1.98564L10.8904 1.78416L11.1682 1.9953L11.0639 1.65463L11.3417 1.44719H11.0004L10.8944 1.10107ZM4.6563 2.88499C4.60781 2.92115 4.55964 2.95775 4.51179 2.99476L4.74392 3.17125L4.6563 2.88499ZM6.30561 2.277L6.19846 2.62311H5.85833L6.13366 2.83238L6.03175 3.16157L6.30163 2.96008L6.57944 3.17123L6.47512 2.83055L6.75289 2.62311H6.4116L6.30561 2.277ZM8.14113 2.277L8.03398 2.62311H7.69385L7.96918 2.83238L7.86727 3.16157L8.13715 2.96008L8.41496 3.17123L8.31064 2.83055L8.58842 2.62311H8.24713L8.14113 2.277ZM9.97665 2.277L9.8695 2.62311H9.52937L9.8047 2.83238L9.70279 3.16157L9.97267 2.96008L10.2505 3.17123L10.1462 2.83055L10.4239 2.62311H10.0826L9.97665 2.277ZM3.64981 3.7713C3.54809 3.87898 3.4487 3.98883 3.35171 4.10079L3.27845 4.33745L3.54835 4.13595L3.82613 4.3471L3.72182 4.00646L3.9996 3.799H3.65829L3.64981 3.7713ZM5.38785 3.45288L5.2807 3.79899H4.94057L5.21589 4.00826L5.11399 4.33745L5.38387 4.13596L5.66168 4.34711L5.55735 4.00643L5.83514 3.79899H5.49384L5.38785 3.45288ZM7.22337 3.45288L7.11622 3.79899H6.77609L7.05141 4.00826L6.94951 4.33745L7.21939 4.13596L7.4972 4.34711L7.39288 4.00643L7.67065 3.79899H7.32936L7.22337 3.45288ZM9.05889 3.45288L8.95174 3.79899H8.61161L8.88694 4.00826L8.78503 4.33745L9.05491 4.13596L9.33272 4.34711L9.2284 4.00643L9.50617 3.79899H9.16489L9.05889 3.45288ZM10.8944 3.45288L10.7873 3.79899H10.4471L10.7225 4.00826L10.6205 4.33745L10.8904 4.13596L11.1682 4.34711L11.0639 4.00643L11.3417 3.79899H11.0004L10.8944 3.45288ZM2.71247 4.88312C2.61745 5.00975 2.52536 5.13855 2.43628 5.26942L2.36075 5.51338L2.63056 5.31188L2.90843 5.52303L2.80411 5.18239L3.08182 4.97493H2.74058L2.71247 4.88312ZM4.47009 4.62881L4.36294 4.97492H4.02281L4.29813 5.18419L4.19623 5.51338L4.46611 5.31189L4.74392 5.52303L4.6396 5.18236L4.91738 4.97492H4.57608L4.47009 4.62881ZM6.30561 4.62881L6.19846 4.97492H5.85833L6.13366 5.18419L6.03175 5.51338L6.30163 5.31189L6.57944 5.52303L6.47512 5.18236L6.75289 4.97492H6.4116L6.30561 4.62881ZM8.14113 4.62881L8.03398 4.97492H7.69385L7.96918 5.18419L7.86727 5.51338L8.13715 5.31189L8.41496 5.52303L8.31064 5.18236L8.58842 4.97492H8.24713L8.14113 4.62881ZM9.97665 4.62881L9.8695 4.97492H9.52937L9.8047 5.18419L9.70279 5.51338L9.97267 5.31189L10.2505 5.52303L10.1462 5.18236L10.4239 4.97492H10.0826L9.97665 4.62881ZM1.90815 6.15086C1.84651 6.26638 1.78709 6.38305 1.7299 6.50082L1.99065 6.69897L1.88633 6.35832L2.16411 6.15086H1.90815ZM3.55233 5.80473L3.44519 6.15085H3.10505L3.38038 6.36012L3.27847 6.6893L3.54835 6.48782L3.82616 6.69896L3.72184 6.35829L3.99962 6.15085H3.65832L3.55233 5.80473ZM5.38785 5.80473L5.2807 6.15085H4.94057L5.21589 6.36012L5.11399 6.6893L5.38387 6.48782L5.66168 6.69896L5.55735 6.35829L5.83514 6.15085H5.49384L5.38785 5.80473ZM7.22337 5.80473L7.11622 6.15085H6.77609L7.05141 6.36012L6.94951 6.6893L7.21939 6.48782L7.4972 6.69896L7.39288 6.35829L7.67065 6.15085H7.32936L7.22337 5.80473ZM9.05889 5.80473L8.95174 6.15085H8.61161L8.88694 6.36012L8.78503 6.6893L9.05491 6.48782L9.33272 6.69896L9.2284 6.35829L9.50617 6.15085H9.16489L9.05889 5.80473ZM10.8944 5.80473L10.7873 6.15085H10.4471L10.7225 6.36012L10.6205 6.6893L10.8904 6.48782L11.1682 6.69896L11.0639 6.35829L11.3417 6.15085H11.0004L10.8944 5.80473ZM2.63457 6.98061L2.52743 7.32673H2.18729L2.46262 7.536L2.36071 7.86518L2.63059 7.6637L2.9084 7.87484L2.80408 7.53417L3.08186 7.32673H2.74056L2.63457 6.98061ZM4.47009 6.98061L4.36294 7.32673H4.02281L4.29813 7.536L4.19623 7.86518L4.46611 7.6637L4.74392 7.87484L4.6396 7.53417L4.91738 7.32673H4.57608L4.47009 6.98061ZM6.30561 6.98061L6.19846 7.32673H5.85833L6.13366 7.536L6.03175 7.86518L6.30163 7.6637L6.57944 7.87484L6.47512 7.53417L6.75289 7.32673H6.4116L6.30561 6.98061ZM8.14113 6.98061L8.03398 7.32673H7.69385L7.96918 7.536L7.86727 7.86518L8.13715 7.6637L8.41496 7.87484L8.31064 7.53417L8.58842 7.32673H8.24713L8.14113 6.98061ZM9.97665 6.98061L9.8695 7.32673H9.52937L9.8047 7.536L9.70279 7.86518L9.97267 7.6637L10.2505 7.87484L10.1462 7.53417L10.4239 7.32673H10.0826L9.97665 6.98061ZM1.71681 8.15654L1.60967 8.50265H1.26953L1.54486 8.71192L1.44295 9.04111L1.71283 8.83962L1.99064 9.05077L1.88632 8.71009L2.1641 8.50265H1.82281L1.71681 8.15654ZM3.55233 8.15654L3.44519 8.50265H3.10505L3.38038 8.71192L3.27847 9.04111L3.54835 8.83962L3.82616 9.05077L3.72184 8.71009L3.99962 8.50265H3.65832L3.55233 8.15654ZM5.38785 8.15654L5.2807 8.50265H4.94057L5.21589 8.71192L5.11399 9.04111L5.38387 8.83962L5.66168 9.05077L5.55735 8.71009L5.83514 8.50265H5.49384L5.38785 8.15654ZM7.22337 8.15654L7.11622 8.50265H6.77609L7.05141 8.71192L6.94951 9.04111L7.21939 8.83962L7.4972 9.05077L7.39288 8.71009L7.67065 8.50265H7.32936L7.22337 8.15654ZM9.05889 8.15654L8.95174 8.50265H8.61161L8.88694 8.71192L8.78503 9.04111L9.05491 8.83962L9.33272 9.05077L9.2284 8.71009L9.50617 8.50265H9.16489L9.05889 8.15654ZM10.8944 8.15654L10.7873 8.50265H10.4471L10.7225 8.71192L10.6205 9.04111L10.8904 8.83962L11.1682 9.05077L11.0639 8.71009L11.3417 8.50265H11.0004L10.8944 8.15654ZM2.63457 9.33247L2.52743 9.67858H2.18729L2.46262 9.88785L2.36071 10.217L2.63059 10.0155L2.9084 10.2267L2.80408 9.88602L3.08186 9.67858H2.74056L2.63457 9.33247ZM4.47009 9.33247L4.36294 9.67858H4.02281L4.29813 9.88785L4.19623 10.217L4.46611 10.0155L4.74392 10.2267L4.6396 9.88602L4.91738 9.67858H4.57608L4.47009 9.33247ZM6.30561 9.33247L6.19846 9.67858H5.85833L6.13366 9.88785L6.03175 10.217L6.30163 10.0155L6.57944 10.2267L6.47512 9.88602L6.75289 9.67858H6.4116L6.30561 9.33247ZM8.14113 9.33247L8.03398 9.67858H7.69385L7.96918 9.88785L7.86727 10.217L8.13715 10.0155L8.41496 10.2267L8.31064 9.88602L8.58842 9.67858H8.24713L8.14113 9.33247ZM9.97665 9.33247L9.8695 9.67858H9.52937L9.8047 9.88785L9.70279 10.217L9.97267 10.0155L10.2505 10.2267L10.1462 9.88602L10.4239 9.67858H10.0826L9.97665 9.33247ZM1.71681 10.5083L1.60967 10.8545H1.26953L1.54486 11.0637L1.44295 11.3929L1.71283 11.1914L1.99064 11.4026L1.88632 11.0619L2.1641 10.8545H1.82281L1.71681 10.5083ZM3.55233 10.5083L3.44519 10.8545H3.10505L3.38038 11.0637L3.27847 11.3929L3.54835 11.1914L3.82616 11.4026L3.72184 11.0619L3.99962 10.8545H3.65832L3.55233 10.5083ZM5.38785 10.5083L5.2807 10.8545H4.94057L5.21589 11.0637L5.11399 11.3929L5.38387 11.1914L5.66168 11.4026L5.55735 11.0619L5.83514 10.8545H5.49384L5.38785 10.5083ZM7.22337 10.5083L7.11622 10.8545H6.77609L7.05141 11.0637L6.94951 11.3929L7.21939 11.1914L7.4972 11.4026L7.39288 11.0619L7.67065 10.8545H7.32936L7.22337 10.5083ZM9.05889 10.5083L8.95174 10.8545H8.61161L8.88694 11.0637L8.78503 11.3929L9.05491 11.1914L9.33272 11.4026L9.2284 11.0619L9.50617 10.8545H9.16489L9.05889 10.5083ZM10.8944 10.5083L10.7873 10.8545H10.4471L10.7225 11.0637L10.6205 11.3929L10.8904 11.1914L11.1682 11.4026L11.0639 11.0619L11.3417 10.8545H11.0004L10.8944 10.5083Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnited);
export default __webpack_public_path__ + "static/media/United.817f66c3947731aacf3300e21604a109.svg";
export { ForwardRef as ReactComponent };